import React, { useMemo, useEffect, useState, memo } from 'react'
import { useSelector } from 'react-redux'

import styled from 'styled-components'
import { useToasts } from 'react-toast-notifications'
import moment from 'moment'

import axiosInstance from '../../../../../services/config/AxiosIntance'

import Table from '../../../../../components/Table'
import Loader from '../../../../../components/Loader'
import Flex from '../../../../../components/layouts/Flex'
import DashboardItemTitle from '../../components/DashboardItemTitle'
import NoData from '../../components/NoData'

import CSVDownloader from '../../../../../lib/CSVDownloader'

const LoginAndSignupsHistory = () => {
  const { addToast } = useToasts()

  const filters = useSelector((state) => state.dashboard.filters)


  const [totalPage, setTotalPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [rowCount, setRowCount] = useState(0)

  const [loading, setLoading] = useState(false)
  const [tableData, setTableData] = useState([])

  useEffect(() => {
    fetchData()
  }, [filters])

  const fetchData = async () => {
    try {
      setLoading(true)

      const queryFilter = {
        dates: filters.dates.toString(),
        recruiter_id: filters.recruiter_id,
        job_id: filters.job_id,
        company_id: filters.company_id,
        channel_id: filters.channel_id,
        stage_id: filters.stage_id
      }
      const queryParams = new URLSearchParams(queryFilter).toString()
      const fetchedPageUrl = `/dashboard/login-activities/fetchPage?${queryParams}&pageNumber=${currentPage}&pageSize=${pageSize}`

      const result = await axiosInstance.get(fetchedPageUrl)

      setTableData(result?.data?.data)

      setTotalPage(result?.data?.pagination?.pageCount)
      setRowCount(result?.data?.pagination?.rowCount)
      setCurrentPage(result?.data?.pagination?.page)
      setPageSize(result?.data?.pagination?.pageSize)
    } catch (error) {
      addToast('Something went wrong', {
        appearance: 'error',
        autoDismiss: true,
      })
    } finally {
      setLoading(false)
    }
  }

  const handleExport = async () => {
    try {
      const queryFilter = {
        dates: filters.dates.toString(),
        recruiter_id: filters.recruiter_id,
        job_id: filters.job_id,
        company_id: filters.company_id,
        channel_id: filters.channel_id,
        stage_id: filters.stage_id
      }
      const queryParams = new URLSearchParams(queryFilter).toString()
      const url = `/dashboard/login-activities/fetchAll?${queryParams}&pageNumber=${currentPage}&pageSize=${pageSize}`
      const result = await axiosInstance.get(url)
      const response = result?.data?.data.map((e) => ({
        'Applicant Id': e.applicant_id,
        Applicant: e.applicant_name,
        Activity: e.activities,
        Category: e.activity_type,
        Status: e.status,
        'Created TimeStamp': moment(e.created_at).format('MM/DD/YYYY'),
        'Modified TimeStamp': moment(e.updated_at).format('MM/DD/YYYY'),
      }))
      CSVDownloader.downloadUnparsedCSV(response, 'Login_Signup_Usage_List.csv')
    } catch (error) {
      addToast('Something went wrong', {
        appearance: 'error',
        autoDismiss: true,
      })
    }
  }

  const tableColumns = useMemo(
    () => [
      {
        Header: 'Applicant',
        accessor: 'applicant_name',
      },
      {
        Header: 'Activity',
        accessor: 'activities',
      },
      {
        Header: 'Category',
        accessor: 'activity_type',
      },
      {
        Header: 'Status',
        accessor: 'status',
      },
      {
        Header: 'Created TimeStamp',
        accessor: 'created_at',
        Cell: ({ value }) => (value ? moment(value).format('MM/DD/YYYY') : ''),
      },
      {
        Header: 'Modified TimeStamp',
        accessor: 'updated_at',
        Cell: ({ value }) => (value ? moment(value).format('MM/DD/YYYY') : ''),
      },
    ],
    []
  )

  return (
    <StyledLoginSignupList>
      <Flex justify="space-between">
        <DashboardItemTitle title="Login & Signup Usage List" />
        <Flex gap="0.5rem">
          <ExportButton onClick={handleExport}>Export</ExportButton>
        </Flex>
      </Flex>

      {loading && <Loader />}

      {tableData?.length > 0 ? (
        <Table
          height="100%"
          totalPage={totalPage}
          currentPage={currentPage}
          pageSize={pageSize}
          rowCount={rowCount}
          data={tableData}
          columns={tableColumns}
          setNewPageSize={setPageSize}
          setCurrentPage={setCurrentPage}
          fetchData={fetchData}
          onClick={() => null}
        ></Table>
      ) : (
        <NoData />
      )}
    </StyledLoginSignupList>
  )
}

export default memo(LoginAndSignupsHistory)

const StyledLoginSignupList = styled.div`
  width: 100%;
  height: 100%;
`
const ExportButton = styled.button`
  padding: 0.35rem 0.65rem;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
  text-overflow: ellipsis;
  overflow: hidden;
  background-color: black;
  color: white;
  border-radius: 100px;
  word-spacing: 3px;
`
